module.exports = __webpack_public_path__ + "static/media/Ecuador.bd0d7036.svg";